import { Injectable } from "@angular/core";
import { EOtpremnicaUpdateComponent } from "./eotpremnica-update.component";
import { BaseDataService, ConfirmationDialogButtons, DefaultListTabsComponent, ErrorHandlerService, ModalService, ModalSize, ModelData, ModelDataService, NotificationService, QueryParameter, TabsContainerService } from "yt-ng-framework";
import { TranslateService } from "@ngx-translate/core";
import { Router } from "@angular/router";
import { EOtpremnica } from "./eotpremnica";
import { HttpErrorResponse } from "@angular/common/http";
import { EOtpremnicaView } from "./eotpremnica-view";
import { EPrijemnicaView } from "../eprijemnica/eprijemnica-view";
import { CommentComponent } from "src/app/lookups/_forme/comment/comment.component";
import { EPrijemnica } from "../eprijemnica/eprijemnica";
import { EOtpremnicaTabUpdateComponent } from "./eotpremnica-tab-update.component";
import { EOtpremnicaTabsComponent } from "./eotpremnica-tabs.component";
import { translate } from "@angular/localize/src/utils";

@Injectable({
    providedIn: 'root'
  })
  export class EOtpremnicaService {
    constructor(
        protected baseDataService: BaseDataService,
        protected translateService: TranslateService,
        protected modalService: ModalService,
        protected errorService: ErrorHandlerService,
        protected modelDataService: ModelDataService,
        protected router: Router,
        protected toastrService: NotificationService
  ) {   }

  public baseUpdateComponent: EOtpremnicaUpdateComponent
  public baseTabsComponent: EOtpremnicaTabsComponent
  public baseTabUpdate: EOtpremnicaTabUpdateComponent

  checkUnsavedChanges (
    modalFunction: () => void, 

  ) {
      if (!this.baseUpdateComponent.canDeactivate()) {
          this.modalService.ShowConfirmationDialog(
              "Obaveštenje",
              'Postoje promene u tekućim podacima. Da li želite da ih sačuvate pre nastavka?',
              "question",
              ConfirmationDialogButtons.ConfirmCancel 
          ).result.then((result) => {
              if (result === ConfirmationDialogButtons.ConfirmCancel || result === true) {
                  this.baseUpdateComponent.SaveItem(); 
                  modalFunction(); 
              }
             
          }).catch(() => {});
      } else {
          modalFunction(); 
      }
  }
    PocetakVoznje(){
  let id: number = this.baseUpdateComponent.baseFormGroup.get("ID").value;
  this.PocetakVoznjeService(id);
}

  PocetakVoznjeService(id:number) {
    let idParameter = new QueryParameter("id", id);
    let vrsta = this.baseUpdateComponent.modelData["MainList"]["UserRightsModelName"];
    let vrstaParameter = new QueryParameter("vrsta",vrsta);
    this.baseDataService
          .GetByID("Eotpremnica",id,EOtpremnica)
          .toPromise().then((item: EOtpremnica) =>{
            this.baseDataService
            .Get("EOtpremnica","OsveziStatus",[idParameter,vrstaParameter],EOtpremnicaView)
            .toPromise().then((data:EOtpremnicaView[])=>{
              let tooltip = data[0].StatusGenericName;
              if (tooltip != item.StatusGenericName){
                this.translateService.get([tooltip]) 
                  .subscribe(translate => {
                    this.modalService.ShowConfirmationDialog(
                      "Obaveštenje",
                      translate[tooltip],
                      "alert",
                      ConfirmationDialogButtons.Ok
                    );   

                    this.OsveziStatus(id);
                    
                  })
                  return false;
                }   
            this.getProvajderGenericName(item.ProvajderID).subscribe(
              (genericName: any) => {
                if (
                  genericName == "Sef_t" ||
                  genericName == "Sef_p"
                ){
                  let _masterDokumID: Number = item.MasterDokumID;           
                  let salji = true; 
                  let _modelData = this.modelDataService.GetModelDataByPath("pocetak-voznje"); 
                  
                  let idParameter = new QueryParameter ("eOtpremnicaId", id);
                  let naslovParameter = new QueryParameter (
                    "naslov",
                    "COMMENT.POCETAKVOZNJE.SINGULAR"
                  );  
                  
                   _modelData.ModalSize = ModalSize.Lg;
    
                  if (salji){   
                    
                    let masterIdParameter = new QueryParameter (
                      "masterDokumID"
                      ,_masterDokumID
                    ); 
    
                    if (_modelData){
                      this.modalService
                        .ShowModal(0,_modelData,null,true, [
                        idParameter
                        ,masterIdParameter
                      ])
                      .result.then(
                        (item) => {

                            this.OsveziStatus(id);
                        },
                        (reason) => {}
                      )
                    }
                  }
                }
              });
          });
      });
  }

StornoDokument(){
  let id: number = this.baseUpdateComponent.baseFormGroup.get("ID").value;
  this.StornoService(id);
}

StornoService(id: number){
  let idParameter = new QueryParameter("id", id);
  let vrsta = this.baseUpdateComponent.modelData["MainList"]["UserRightsModelName"];
  let vrstaParameter = new QueryParameter("vrsta",vrsta);
  this.baseDataService
  .GetByID("Eotpremnica",id,EOtpremnica)
  .toPromise().then((item: EOtpremnica) =>{
    this.baseDataService
    .Get("EOtpremnica","OsveziStatus",[idParameter,vrstaParameter],EOtpremnicaView)
    .toPromise().then((data:EOtpremnicaView[])=>{
      let tooltip = data[0].StatusGenericName;
      if (tooltip != item.StatusGenericName){
        this.translateService.get([tooltip]) 
          .subscribe(translate => {
            this.modalService.ShowConfirmationDialog(
              "Obaveštenje",
              translate[tooltip],
              "alert",
              ConfirmationDialogButtons.Ok
            );   

            this.OsveziStatus(id);
            
          })
          return false;
        }   
      
    
    this.getProvajderGenericName(item.ProvajderID).subscribe(
      (genericName: any) => {
        if (
          genericName == "Sef_t" ||
          genericName == "Sef_p"
        ){
          let idParameter = new QueryParameter("eOtpremnicaId",id);

          let naslovParameter = new QueryParameter (
            "naslov",
            "COMMENT.STORNO.SINGULAR"
          );
          let brojParameter = new QueryParameter(
            "brojOtpremnice",
            item.BrojOtpremnice
          );
          let razlogStorniranja = new QueryParameter (
            "razlogStorniranja",
            "COMMENT.STORNO.REASON.SINGULAR"
          );

          let modelData = new ModelData(null);
          modelData.ModalSize = ModalSize.Md;
          modelData.UpdateComponent = CommentComponent;

          if (modelData){
            this.modalService.ShowModal(0,modelData, null, true, [
              naslovParameter,
              razlogStorniranja,
              brojParameter
            ])
            .result.then(
              (result) => {
                    if (result && result != ""){
                      let _result : string = result;
                      let stornoCommentParameter = new QueryParameter("stornoComment", _result.split(";")[0] == '' ? 'null' : _result.split(';')[0]);
                      let stornoDespatchNumberParameter = new QueryParameter("stornoDespatchNumber", _result.split(';')[1] == '' ? 'null' : _result.split(';')[1]);                        
                      this.baseDataService
                      .Get("EOtpremnica","StornoDokument",[idParameter, stornoCommentParameter, stornoDespatchNumberParameter], null)
                      .subscribe(
                        (poruka: any) => {
                          this.OsveziStatus(id);
                          this.translateService
                          .get(['EDOKUMENT.STORNO.SUCESS'])
                          .subscribe(translate => {
                            setTimeout(()=>{
                              this.toastrService.success(translate['EDOKUMENT.STORNO.SUCESS'], poruka);
                            }, 0)

                          });
                        }
                        , error => {
                          let _message;
                          let translatedMessage: string = "";
                          if (error instanceof HttpErrorResponse) {
                            _message = this.errorService.getServerMessage(error);
                            if (_message instanceof ArrayBuffer) {
                              _message = new TextDecoder('utf-8').decode(new Uint8Array(_message));
                              let message: string = _message;
                              if (message.includes('EDOKUMENT')){
                                let messageArray: string[] = message.split(';');
                                messageArray.forEach((element, index) => {
                                  messageArray[index] = "FW.ERRORS." + element;
                                });
                                this.translateService.get(messageArray)
                                .subscribe(translate => {
                                  translatedMessage = Object.keys(translate).map(key => translate[key]).join('\r\n');
                                });
                              }
                              else 
                                translatedMessage = message;
                            }
                            else{
                              translatedMessage = this.errorService.getClientMessage(error.error);
                            }
                          }
                          this.modalService.ShowConfirmationDialog(
                            "Problemi kod storiranja", 
                            translatedMessage, 
                            "warning", 
                            ConfirmationDialogButtons.Ok);
                        }
                      );
                    }
              },
              (reason) => {}
            );
          } else{
            this.modalService.ShowConfirmationDialog(
              "Obaveštenje",
              "Ova opcija trenutno nije implementirana za SEF",
              "alert",
              ConfirmationDialogButtons.Ok
            );
          }
        }
      }
    );
  });


});

  
}

   getProvajderGenericName(id: number) {
    var parameters = [];
    var provajderId = new QueryParameter();
    provajderId.Name = "id";
    provajderId.Value = id;
    parameters.push(provajderId);
    return this.baseDataService.Get(
      "Provajder",
      "getGenericName",
      parameters,
      null
    );
  }

  FizickiPrijem(){
  let id: number = this.baseUpdateComponent.baseFormGroup.get("ID").value;
  this.FizickiPrijemService(id);
  
}

FizickiPrijemService(id:number){
  this.baseDataService
      .GetByID("Eotpremnica",id,EOtpremnica)
      .subscribe((item: EOtpremnica) => {
        this.getProvajderGenericName(item.ProvajderID).subscribe(
          (genericName: any) => {
            if (
              genericName == "Sef_t" ||
              genericName == "Sef_p"
            ){
              this.translateService.get(["EOTPREMNICA.FIZICKIPRIJEM.SINGULAR","EOTPREMNICA.FIZICKIPRIJEM.QUESTION"])
              .subscribe(translate => {
              this.modalService.ShowConfirmationDialog(translate["EOTPREMNICA.FIZICKIPRIJEM.SINGULAR"],
                translate["EOTPREMNICA.FIZICKIPRIJEM.QUESTION"],
                "info",ConfirmationDialogButtons.YesNo)
                .result.then(
                  (result) =>{
                    if (result === false)
                      return;
  
                    let idParameter = new QueryParameter("eOtpremnicaId",id);
                    this.baseDataService.Get("EOtpremnica","FizickiPrijem",[idParameter],null)
                    .subscribe(
                      (poruka: any) => {
                          if (poruka)
                              this.OsveziStatus(id);
                              this.translateService
                              .get(['EOTPREMNICA.FIZICKIPRIJEM.SUCESS'])
                              .subscribe(translate => {
                                setTimeout(()=>{
                                  this.toastrService.success(translate['EOTPREMNICA.FIZICKIPRIJEM.SUCESS'], poruka);
                                }, 0)

                              });
                            }
                            , error => {
                              let _message;
                              let translatedMessage: string = "";
                              if (error instanceof HttpErrorResponse) {
                                _message = this.errorService.getServerMessage(error);
                                if (_message instanceof ArrayBuffer) {
                                  _message = new TextDecoder('utf-8').decode(new Uint8Array(_message));
                                  let message: string = _message;
                                  if (message.includes('EOTPREMNICA')){
                                    let messageArray: string[] = message.split(';');
                                    messageArray.forEach((element, index) => {
                                      messageArray[index] = "FW.ERRORS." + element;
                                    });
                                    this.translateService.get(messageArray)
                                    .subscribe(translate => {
                                      translatedMessage = Object.keys(translate).map(key => translate[key]).join('\r\n');
                                    });
                                  }
                                  else 
                                    translatedMessage = message;
                                }
                                else{
                                  translatedMessage = this.errorService.getClientMessage(error.error);
                                }
                              }
                              this.modalService.ShowConfirmationDialog(
                                "Problemi kod fizičkog prijema", 
                                translatedMessage, 
                                "warning", 
                                ConfirmationDialogButtons.Ok);
                            }
                    )
                  }
                )
  
              })
            }
          }
        )})
}
brojPrijemnice: string;
KreirajPrijemnicu(){
  let id: number = this.baseUpdateComponent.baseFormGroup.get("ID").value;
  this.KreirajPrijemnicuService(id);  
}

KreirajPrijemnicuService(id: number){
  this.baseDataService
      .GetByID("Eotpremnica",id,EOtpremnica)
      .subscribe((item: EOtpremnica) => {
        this.getProvajderGenericName(item.ProvajderID).subscribe(
          (genericName: any) => {
            if (
              genericName == "Sef_t" ||
              genericName == "Sef_p"
            ){
              this.translateService.get(["EOTPREMNICA.KREIRAJPRIJEMNICU.SINGULAR","EOTPREMNICA.KREIRAJPRIJEMNICU.QUESTION"])
              .subscribe(translate => {
              this.modalService.ShowConfirmationDialog(translate["EOTPREMNICA.KREIRAJPRIJEMNICU.SINGULAR"],
                translate["EOTPREMNICA.KREIRAJPRIJEMNICU.QUESTION"],
                "info",ConfirmationDialogButtons.YesNo)
                .result.then(
                  (result) =>{
                    if (result === false)
                      return;
  
                    let idParameter = new QueryParameter("eOtpremnicaId",id);
                    let idParameter2 = new QueryParameter("id", id);

                    this.baseDataService.Get("EPrijemnica","KreirajPrijemnicu",[idParameter],EPrijemnicaView)
                    .subscribe(
                      (prijemnica: EPrijemnicaView[]) => {
                              this.translateService
                              .get(['EOTPREMNICA.KREIRAJPRIJEMNICU.SUCESS'])
                              .subscribe(async translate => {
                                setTimeout(()=>{
                                  this.toastrService.success(translate['EOTPREMNICA.KREIRAJPRIJEMNICU.SUCESS'], prijemnica["BrojDokumenta"]);
                                  }, 0)

                                  //this.brojPrijemnice = prijemnica[0].BrojPrijemnice;
                                
                                const refreshedItem: any = await this.baseDataService 
                                  .Get("EOtpremnica","GetViewItemByID",[idParameter2], EOtpremnicaView)
                                  .toPromise();
                                this.baseTabsComponent.tabsContainerService.EmitItem(refreshedItem);
                                this.baseTabsComponent.baseTabsUpdate['brojPrijemnice'] = prijemnica["BrojPrijemnice"];

                              });
                            }
                            , error => {
                              let _message;
                              let translatedMessage: string = "";
                              if (error instanceof HttpErrorResponse) {
                                _message = this.errorService.getServerMessage(error);
                                // if (_message instanceof ArrayBuffer) {
                                //   _message = new TextDecoder('utf-8').decode(new Uint8Array(_message));
                                  let message: string = _message;
                                  if (message.includes('EOTPREMNICA')){
                                    let messageArray: string[] = message.split(';');
                                    messageArray.forEach((element, index) => {
                                      messageArray[index] = "FW.ERRORS." + element;
                                    });
                                    this.translateService.get(messageArray)
                                    .subscribe(translate => {
                                      translatedMessage = Object.keys(translate).map(key => translate[key]).join('\r\n');
                                    });
                                  // }
                                  // else 
                                  //   translatedMessage = message;
                                }
                                else{
                                  translatedMessage = this.errorService.getClientMessage(error.error);
                                }
                              }
                              this.modalService.ShowConfirmationDialog(
                                "Problemi kod kreiranja prijemnice", 
                                translatedMessage, 
                                "warning", 
                                ConfirmationDialogButtons.Ok);
                            }
                    )
                  }
                )
  
              })
            }
          }
        )})
}



prevod: string;
bojaStatusa: string;
nazivStatusa: string;
OsveziStatus(id: number){

    this.baseTabUpdate.defaultUpdateButtons.ButtonsConfig.ContextMenuButtonConfig.Enable = false;
    let idParameter = new QueryParameter("id",id);
    let vrsta = this.baseUpdateComponent.modelData["MainList"]["UserRightsModelName"];
    let vrstaParameter = new QueryParameter("vrsta",vrsta);
    this.baseDataService 
        .Get("EOtpremnica","OsveziStatus",[idParameter,vrstaParameter], EOtpremnicaView)
        .subscribe(async (data: EOtpremnicaView[]) =>{
          
          if (data != null && data.length > 0)
          {
            this.bojaStatusa = data[0].StatusColor;
            this.nazivStatusa = data[0].StatusTooltip;
          }
          else 
          {
            this.bojaStatusa = "transparent";
            this.nazivStatusa = ""
          }

          const refreshedItem: any = await this.baseDataService 
             .Get("EOtpremnica","GetViewItemByID",[idParameter], EOtpremnicaView)
             .toPromise();
          this.baseTabsComponent.tabsContainerService.EmitItem(refreshedItem);     
          this.baseTabsComponent.baseTabsUpdate['bojaStatusa'] = this.bojaStatusa; 
          this.baseTabsComponent.baseTabsUpdate.baseUpdateComponent.Item.StatusGenericName = data[0].StatusGenericName; 
          this.baseTabUpdate.defaultUpdateButtons.ButtonsConfig.ContextMenuButtonConfig.Enable = true;
          this.baseTabsComponent.baseTabsUpdate['nazivStatusa'] = this.nazivStatusa;
 
        }
        ,error => {
            throw error;
        });
  
}

PromenaVozila(){
  let id: number = this.baseUpdateComponent.baseFormGroup.get("ID").value;
  this.PromenaVozilaService(id);
}


PromenaVozilaService(id: number){
  let idParameter = new QueryParameter("id", id);
  let vrsta = this.baseUpdateComponent.modelData["MainList"]["UserRightsModelName"];
  let vrstaParameter = new QueryParameter("vrsta",vrsta);
 this.baseDataService
      .GetByID("Eotpremnica",id,EOtpremnica)
       .toPromise().then((item: EOtpremnica) =>{
        this.baseDataService
        .Get("EOtpremnica","OsveziStatus",[idParameter,vrstaParameter],EOtpremnicaView)
        .toPromise().then((data:EOtpremnicaView[])=>{
        let tooltip = data[0].StatusGenericName;  
            if (tooltip != item.StatusGenericName){
                this.translateService.get([tooltip]) 
                  .subscribe(translate => {
                    this.modalService.ShowConfirmationDialog(
                      "Obaveštenje",
                      translate[tooltip],
                      "alert",
                      ConfirmationDialogButtons.Ok
                    );   

                    this.OsveziStatus(id);
                    
                  })
                  return false;
                } 
        this.getProvajderGenericName(item.ProvajderID).subscribe(
          (genericName: any) => {
            if (
              genericName == "Sef_t" ||
              genericName == "Sef_p"
            ){
              let _masterDokumID: Number = item.MasterDokumID;
              let salji = true;
              let _modelData = this.modelDataService.GetModelDataByPath("promena-vozila");

               let idParameter = new QueryParameter ("eOtpremnicaId", id);

              let naslovParameter = new QueryParameter (
                    "naslov",
                    "COMMENT.PROMENAVOZILA.SINGULAR"
                  );  
                  
                   _modelData.ModalSize = ModalSize.Lg;
    
                  if (salji){   
                    
                    let masterIdParameter = new QueryParameter (
                      "masterDokumID"
                      ,_masterDokumID
                    ); 
    
                    if (_modelData){
                      this.modalService
                        .ShowModal(0,_modelData,null,true, [
                        idParameter
                        ,masterIdParameter
                      ])
                      .result.then(
                        (item) => {
                          // if (item.OsvezivogStatusa)
                            this.OsveziStatus(id);
                        },
                        (reason) => {}
                     )
                    }
                  }
                }
              });
          });
      });
  }
}
